import * as React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import LoginRequiredPage from '../containers/LoginRequiredPage'

export const PrivateRoute = ({ isAllowed, children, redirectTo }) => {
  const tokenLocal = window.localStorage.getItem('arbolQR_Token')

  if (!isAllowed) {
    if (redirectTo) return <Navigate to={redirectTo} />
    if (tokenLocal)
      return (
        <Backdrop
          sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
          open={!isAllowed}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )
    return <LoginRequiredPage titlelb="El acceso al sitio está restringido" />
  }

  return children ?? <Outlet />
}
